import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeft, BarChart3, Search } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { JoOverdueBanner } from '@/components/processingJo/JoOverdueBanner';
import { PendingStockReport } from '@/components/processingJo/PendingStockReport';
import { JobberPendingReport } from '@/components/processingJo/JobberPendingReport';
import { TraceReport } from '@/components/processingJo/TraceReport';
import { JobberScorecard } from '@/components/processingJo/JobberScorecard';
import { TraceCodePanel } from '@/components/processingJo/TraceCodePanel';

const TABS = [['pending', 'Pending stock'], ['jobbers', 'Jobber-wise pending'], ['trace', 'Traceability'], ['scorecard', 'Jobber scorecard'], ['code', 'Trace a code']];
const SEARCHABLE = ['pending', 'jobbers', 'trace'];

export default function ProcessingJobOrderReports() {
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const tab = TABS.some(([v]) => v === params.get('tab')) ? params.get('tab') : 'pending';
  const [q, setQ] = useState('');

  return (
    <div className="min-h-screen bg-[#FFFBF5]" data-testid="processing-jo-reports">
      <header className="bg-[#1A1F2E] text-white shadow-lg pt-10 sm:pt-0">
        <div className="max-w-7xl mx-auto px-4 md:px-6 h-16 flex items-center gap-3">
          <Button variant="ghost" onClick={() => navigate('/sections/processing/job-orders')} className="text-white hover:bg-white/10" data-testid="jo-reports-back-btn"><ArrowLeft className="w-5 h-5" /></Button>
          <BarChart3 className="w-6 h-6 text-amber-400 hidden sm:block" />
          <div className="min-w-0"><h1 className="text-lg sm:text-xl font-bold truncate">Job Order Reports</h1>
            <p className="text-xs text-[#E8DCC8] hidden sm:block">Pending stock, jobber-wise pending, traceability, jobber scorecard and code tracing</p></div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 md:px-6 py-6 space-y-4">
        {tab !== 'code' && <JoOverdueBanner testId="jo-reports-overdue-banner" />}
        <div className="flex flex-wrap items-center gap-3">
          <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
            <TabsList className="flex-wrap h-auto">
              {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} data-testid={`jo-reports-tab-${v}`}>{l}</TabsTrigger>)}
            </TabsList>
          </Tabs>
          {SEARCHABLE.includes(tab) && <div className="relative flex-1 min-w-[220px]"><Search className="w-4 h-4 absolute left-3 top-3 text-gray-400" />
            <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search job order, FG, design, jobber" className="pl-9 bg-white" data-testid="jo-reports-search" /></div>}
        </div>
        {tab === 'pending' && <PendingStockReport q={q.trim()} />}
        {tab === 'jobbers' && <JobberPendingReport q={q.trim()} />}
        {tab === 'trace' && <TraceReport q={q.trim()} />}
        {tab === 'scorecard' && <JobberScorecard />}
        {tab === 'code' && <TraceCodePanel />}
      </main>
    </div>
  );
}
